import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class JumpoutsService {
	apiUrl = environment.serverUrl;
	constructor(private httpClient: HttpClient) {}

	public getJumpouts(pageNum: any, data: any): Observable<any> {
		return this.httpClient.post(this.apiUrl + 'jumpouts-search?page=' + pageNum, data);
	}
}
